import { code } from "@spscommerce/utils";

export const SpsConditionalFieldExamples = {
    basic: {
        examples: {
            basic: {
                template: code`
                    <form [formGroup]="form">
                        <sps-label for="cfGroup">Label</sps-label>
                        <sps-input-group stacked formGroupName="cfGroup">
                            <sps-checkbox label="Checkbox Option 1" formControlName="checkOne">
                            </sps-checkbox>
                            <sps-conditional-field *ngIf="form?.get('cfGroup.checkOne')?.value">
                                <sps-text-input formControlName="textInput" title="Thing" placeholder="Enter a thing"></sps-text-input>
                            </sps-conditional-field>
                            <sps-checkbox label="Checkbox Option 2" formControlName="checkTwo">
                            </sps-checkbox>
                            <sps-checkbox label="Checkbox Option 3" formControlName="checkThree">
                            </sps-checkbox>
                            <sps-checkbox label="Checkbox Option 4" formControlName="checkFour">
                            </sps-checkbox>
                        </sps-input-group>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        form: FormGroup;

                        constructor(private formBuilder: FormBuilder) {}

                        ngOnInit() {
                            this.form = this.formBuilder.group({
                                cfGroup: this.formBuilder.group({
                                    checkOne: [true],
                                    checkTwo: [],
                                    checkThree: [],
                                    checkFour: [],
                                    textInput: [""],
                                })
                            });
                        }
                    }
                `
            },
            nested: {
                label: "Nested Conditional Fields",
                template: code`
                    <form [formGroup]="form">
                        <sps-label for="cfGroup">Label</sps-label>
                        <sps-input-group formGroupName="cfGroup" stacked>
                            <sps-checkbox label="Checkbox Option 1" formControlName="checkOne">
                            </sps-checkbox>
                            <sps-conditional-field *ngIf="form?.get('cfGroup.checkOne')?.value">
                                <sps-label for="radioGroup">Radio Label</sps-label>
                                <sps-input-group formGroupName="radioGroup">
                                    <sps-radio-button value="a" label="Option A"
                                        formControlName="radio">
                                    </sps-radio-button>
                                    <sps-radio-button value="b" label="Option B"
                                        formControlName="radio">
                                    </sps-radio-button>
                                </sps-input-group>
                                <sps-conditional-field *ngIf="form?.get('cfGroup.radioGroup.radio')?.value === 'a'">
                                    <sps-text-input formControlName="textInput" title="Thing" placeholder="Enter a thing"></sps-text-input>
                                </sps-conditional-field>
                            </sps-conditional-field>
                            <sps-checkbox label="Checkbox Option 2" formControlName="checkTwo">
                            </sps-checkbox>
                            <sps-checkbox label="Checkbox Option 3" formControlName="checkThree">
                            </sps-checkbox>
                            <sps-checkbox label="Checkbox Option 4" formControlName="checkFour">
                            </sps-checkbox>
                        </sps-input-group>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        form: FormGroup;

                        constructor(private formBuilder: FormBuilder) {}

                        ngOnInit() {
                            this.form = this.formBuilder.group({
                                cfGroup: this.formBuilder.group({
                                    checkOne: [true],
                                    checkTwo: [],
                                    checkThree: [],
                                    checkFour: [],
                                    radioGroup: this.formBuilder.group({
                                        radio: ["a"],
                                    }),
                                    textInput: [""],
                                })
                            });
                        }
                    }
                `
            }
        }
    },
};
